import React from "react";

const BusRatesTable = () => {
  const ratesData = [
    {
      busName: "FORCE URBANIA",
      seater: "12 / 14 / 17 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
    {
      busName: "LUXURY URBANIA",
      seater: "12 / 14 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
    {
      busName: "TEMPO TRAVELLER",
      seater: "13 / 17 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
    {
      busName: "MINI BUS",
      seater: "20 / 25 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
    {
      busName: "AC BUS",
      seater: "32 / 35 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
    {
      busName: "LUXURY AC BUS",
      seater: "40 / 45 / 52 Seater",
      perKm: "ON CALL",
      whatsapp: "917620411277",
      driver: "Extra",
      parking: "Extra",
    },
  ];

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "20px auto",
  };

  const thStyle = {
    backgroundColor: "#EB6157",
    color: "#fff",
    padding: "10px",
    border: "1px solid #ddd",
    fontSize: "15px",
  };

  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: "14px",
  };

  const trEvenStyle = {
    backgroundColor: "#f9f9f9",
  };

  const handleWhatsAppClick = (number, busName) => {
    const message = `Hi, I want to book ${busName}. Please share price details.`;
    const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="container p-0">
      <h3 className="text-center mb-3">Urbania & Bus Rental Rates</h3>

      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Vehicle Type</th>
              <th style={thStyle}>Seating Capacity</th>
              <th style={thStyle}>Rate (Per KM)</th>
              <th style={thStyle}>Driver Food</th>
              <th style={thStyle}>Toll & Parking</th>
              <th style={thStyle}>Book Now</th>
            </tr>
          </thead>

          <tbody>
            {ratesData.map((row, index) => (
              <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
                <td style={tdStyle}>{row.busName}</td>
                <td style={tdStyle}>{row.seater}</td>
                <td style={tdStyle}>{row.perKm}</td>
                <td style={tdStyle}>{row.driver}</td>
                <td style={tdStyle}>{row.parking}</td>
                <td style={tdStyle}>
                  <button
                    onClick={() =>
                      handleWhatsAppClick(row.whatsapp, row.busName)
                    }
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#EB6157",
                      padding: "8px 14px",
                      borderRadius: "6px",
                      color: "#fff",
                      border: "none",
                      fontSize: "14px",
                    }}
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BusRatesTable;
